module.exports = __webpack_public_path__ + "img/edit.8a455a4f.svg";